import { CREATE_ADDSCRORECARD_SUCCESS, CREATE_ADDSCRORECARD_LOADING, CREATE_ADDSCRORECARD_ERROR } from "../../../constant/actionTypes";

const createAdminsAddPlayerScore = (state = {}, action) => {
    switch (action.type) {
        case CREATE_ADDSCRORECARD_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_ADDSCRORECARD_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case CREATE_ADDSCRORECARD_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createAdminsAddPlayerScore;